import { queryClient } from '@/lib/queryClient';
import { useLeagueDetailStore } from '@/stores/LeagueDetailStore';
import { useLeaguesStore } from '@/stores/LeaguesStore';
import { useMyTeamStore } from '@/stores/MyTeamStore';
import { usePastPeriodStore } from '@/stores/PastPeriodStore';
import { usePlayersStore } from '@/stores/PlayersStore';
import { useUserTeamStore } from '@/stores/UserTeamStore';
import { advanceUserSessionGeneration } from '@/lib/userSessionGeneration';
import { session } from '@/lib/session';

/**
 * Clears all state that may contain data belonging to a specific user.
 * Authentication is deliberately handled by the caller so account switches
 * can reset data before atomically committing the newly verified identity.
 */
export const clearUserSessionData = () => {
  advanceUserSessionGeneration();

  // Removing queries destroys/cancels active user requests and also removes
  // user data from keys that do not yet include a user id.
  queryClient.clear();

  useUserTeamStore.getState().clearPersistedTeamData();
  useUserTeamStore.setState({
    selectedTabId: '1',
    currentMatchdayHasStarted: true,
  });
  usePlayersStore.getState().reset();
  useLeagueDetailStore.getState().reset();
  useLeaguesStore.setState({
    leagues: [],
    loading: false,
    error: null,
    joining: false,
    creating: false,
  });
  useMyTeamStore.setState({
    activeManageBooster: null,
    visibleActiveBoosterBanner: null,
    isBoosterPendingConfirmation: false,
  });
  usePastPeriodStore.setState({ selectedPastPeriodId: null });
  // This draft belongs to the guest-to-SSO journey, not to the authenticated
  // user being cleared. It must survive logout/login and WebView recreation.
  session.clear();
};
